import Activities from '@/services/activities'

const fetchBalance = async (context, id) => {
  return new Promise((resolve, reject) => {
    Activities.get(id)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
const save = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Activities.create(payload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  save,
  fetchBalance
}



// WEBPACK FOOTER //
// ./src/features/activities/store/actions.js